exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes blinking{0%,to{opacity:0}50%{opacity:1}}@keyframes right-left{0%{left:70%}50%{left:-50%}to{left:100%}}body{position:relative;font-family:Press Start\\ 2P,cursive;line-height:30px;background-image:url(" + require("../assets/images/texture.png") + ");background-size:15px;background-color:#acecf3;color:#575d6b}body md-content{color:#575d6b;background-color:transparent}body .ui-transition-view.ng-enter{opacity:0;transition:opacity .4s ease}body .ui-transition-view.ng-enter-active,body .ui-transition-view.ng-leave{opacity:1}body .ui-transition-view.ng-leave-active{opacity:0}body canvas{position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);border:4px solid #575d6b}body .credits{font-size:8px;line-height:10px;color:#fff}body footer{display:block;position:fixed;left:0;right:0;bottom:0;padding:0 12px;padding-bottom:6px;background-color:#90debd}.md-button{font-size:10px}.pace{display:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/autoprefixer-loader?{browsers:['last 2 version']}!../~/sass-loader!./common/styles/elements.scss
// module id = 23
// module chunks = 0